module.exports = __webpack_public_path__ + "img/chancesnow.eef6ec4f.png";